import { useState } from "react";
import { Navigate } from "react-router-dom";
import { SplashScreens } from "../components/Splashscreens";
import { useAuth } from "../context/AuthContext";
import { ADMIN_PORTAL_ROLES, hasRole } from "../constants/roles";

export function SmartEntry() {
  const { user, isAuthenticated, loading } = useAuth();
  
  const [hasSeenSplash, setHasSeenSplash] = useState(() => {
    return localStorage.getItem("has_seen_splash") === "true";
  });

  const handleFinishSplash = () => {
    localStorage.setItem("has_seen_splash", "true");
    setHasSeenSplash(true);
  };

  if (loading) {
    return null;
  }

  // Logged in users
  if (isAuthenticated && user) {
    if (hasRole(user.role, ADMIN_PORTAL_ROLES)) {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/home" replace />;
  }

  // Returning guest
  if (hasSeenSplash) {
    return <Navigate to="/login" replace />;
  }

  // First-time visitor
  return <SplashScreens onFinish={handleFinishSplash} />;
}
